import React, { useCallback, useMemo } from 'react'
import { useRouter } from 'next/router'
import { seesaw } from 'common/utils'
import clzz from 'classnames'

export interface LinkerProps {
  className?: string
  isHash?: boolean // <123:321>
  isAddress?: boolean // [123:321]
  text?: string
  children?: React.ReactNode
  cancelBubble?: boolean
  href: string
  onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => false | true | undefined
  target?: string
  style?: React.CSSProperties
}
export default function Linker(props: LinkerProps) {
  const router = useRouter()
  const { className, style, onClick, children, cancelBubble, href, isHash, isAddress, text, target } = props
  const handlerClick = useCallback(
    (e: React.MouseEvent<HTMLAnchorElement>) => {
      cancelBubble && e.stopPropagation()
      !target && e.preventDefault()
      // Disable link if click hander return false
      if (false === onClick?.(e) || target) {
        return
      }
      router.push(href)
    },
    [href, target],
  )
  const linkClass = useMemo(() => {
    return clzz({ 'font-mono': isHash || isAddress }, className)
  }, [isHash, className])

  const renderContent = useMemo<React.ReactNode | null>(() => {
    if (children !== undefined) {
      return children as React.ReactNode
    }
    const str = text || String(href)
    if (isHash) {
      return seesaw({ raw: str, isHash: true }) as string
    }
    if (isAddress) {
      return seesaw({ raw: str, isAddress: true }) as string
    }
    return str as string
  }, [children, isHash, text, href])

  return (
    <a onClick={handlerClick} style={style} className={linkClass} href={String(href)} target={target}>
      <>{renderContent}</>
    </a>
  )
}
